<script setup lang="ts">
import OrSeparator from '@/Components/OrSeparator.vue';
import RegisterForm from '@/Components/RegisterForm.vue';
import SsoButton from '@/Components/SsoButton.vue';
import GuestLayout from '@/Layouts/GuestLayout.vue';
import { Head, Link } from '@inertiajs/vue3';

const props = defineProps({
  email: String,
});

const attemptSsoSignUp = (provider: string) =>
  (location.href = route('sso.register', provider));
</script>

<template>
  <GuestLayout>
    <Head title="Register" />

    <h1 class="mb-2 font-bold text-slate-900 text-xl">Create your account</h1>

    <div class="mb-3 text-sm text-slate-800">
      Already have an account?
      <Link href="/login" class="text-blue-600 font-medium"> Log in </Link>
    </div>

    <div class="mt-4">
      <SsoButton @click.native="() => attemptSsoSignUp('microsoft')">
        <img :src="asset('images/ms-logo.svg')" class="w-5 h-5" />
        <span>Sign up using Microsoft</span>
      </SsoButton>
    </div>

    <OrSeparator class="mt-4 mb-3" />

    <RegisterForm :email="email" />
  </GuestLayout>
</template>
